<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-8 text-center">
                    <h2 class="display-3"> Are you interested in a career in the STEM field? 
                        <span class="text-success"> Do you want to be involved with WIS?</span>
                    </h2>
                    <p class="lead">If you do, sign up for our mentorship program! Hit the button below to navigate to become a mentor or to be matched up with one!</p>
                    <div class="btn-wrapper">
                        <a href="https://forms.gle/BJZWKgu1d1Rfogs6A" class="btn btn-primary mb-3 mb-sm-0">Mentor</a>
                        <a href="https://forms.gle/REPWwwd21PeEESR38" class="btn btn-primary mb-3 mb-sm-0">Mentee</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
